import SectionExploreByTopicV2 from './SectionExploreByTopicV2'

export default SectionExploreByTopicV2
// eslint-disable-next-line import/export
export * from './SectionExploreByTopicV2'
